import React, { useEffect, useId, useRef } from 'react';
import { DSButton } from '../design-system/primitives';
import './FilterDrawer.css';

function FilterDrawer({
  title,
  summary,
  isOpen,
  onOpen,
  onClose,
  onApply,
  onReset,
  applyDisabled,
  resetDisabled,
  showBar = true,
  children
}) {
  const closeButtonRef = useRef(null);
  const drawerId = useId();

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [isOpen]);

  return (
    <div className="filter-drawer">
      {showBar && (
        <div className="filter-drawer__bar">
          <DSButton
            type="button"
            appearance="outline"
            tone="secondary"
            className="filter-drawer__toggle"
            onClick={onOpen}
            aria-expanded={isOpen}
            aria-controls={drawerId}
          >
            Filters
          </DSButton>
          <div className="filter-drawer__summary" aria-live="polite">
            {summary}
          </div>
        </div>
      )}

      {isOpen && (
        <div className="filter-drawer__overlay" onClick={onClose}>
          <div
            className="filter-drawer__panel"
            role="dialog"
            aria-modal="true"
            aria-label={title}
            id={drawerId}
            onClick={(event) => event.stopPropagation()}
          >
            <div className="filter-drawer__header">
              <h2>{title}</h2>
              <button
                ref={closeButtonRef}
                type="button"
                className="filter-drawer__close"
                onClick={onClose}
                aria-label="Close filters"
              >
                X
              </button>
            </div>

            <div className="filter-drawer__content">{children}</div>

            <div className="filter-drawer__actions">
              <DSButton
                type="button"
                appearance="outline"
                tone="secondary"
                onClick={onReset}
                disabled={resetDisabled}
              >
                Reset
              </DSButton>
              <DSButton
                type="button"
                appearance="solid"
                tone="primary"
                onClick={onApply}
                disabled={applyDisabled}
              >
                Apply Filters
              </DSButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterDrawer;
